import React, { FC, useState } from "react";
import { RouterParamType } from "@/model/navModel";
import { BaseFormBox } from "./BaseFormBox";
import { TableBoxMethod } from "./TableBoxMethod";
import { Form } from "@/components/YhFormBox";
import { IForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { TransportFormBox } from "./TransportFormBox";
import { TableBoxAdded } from "./TableBoxAdded";
import { useSalesDetailModel } from "../salesDetailModel";
import { ISalesDetail } from "@/views/sales/salesTypes";
// import { SettleDrawer } from "./SettleDrawer";
import { ReceiptSettleDrawer } from "./receiptSettleDrawer";
import { SettlementDrawer } from "./SettlementDrawer";
import { SettleDrawer } from "./SettleDrawer";


export const BaseDetail: FC<RouterParamType> = ({ formRef, ...detailsInfo }) => {

    const { editFormVal, addFormVal, updateFormVal, clauseChange } = useSalesDetailModel();

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: ISalesDetail) => {
        let contractAmount: number = 0;
        // 贸易条款change
        if ("clause" in changedValues) {
            // debugger;
            contractAmount = clauseChange(detailsInfo.mode, changedValues.clause)
        }
        updateFormVal(detailsInfo.mode, contractAmount ? { ...changedValues, contractAmount } : changedValues);
    }

    const fromConfig: IForm = {
        formRef: formRef as React.MutableRefObject<IYhFormRef<any>>,
        labelCol: { span: 8 },
        labelAlign: "right",
        onChange,
        formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
    }

    return (
        <>
            <Form {...fromConfig}>
                <BaseFormBox {...detailsInfo} />
                <TableBoxMethod {...detailsInfo} />
                <TransportFormBox {...detailsInfo} />
                <TableBoxAdded {...detailsInfo} />
            </Form>
            <SettleDrawer />
            {/* <ReceiptSettleDrawer /> */}
            <SettlementDrawer />
        </>
    )
}